import { render, staticRenderFns } from "./unapprove.vue?vue&type=template&id=7abb0780"
import script from "./unapprove.vue?vue&type=script&lang=js"
export * from "./unapprove.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports